<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "OsobaRazdobljeBase"
};
</script>

<style scoped>

</style>
